import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Typography, Grid, debounce, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextArea from "../commoncomponents/CustomTextArea";
import ComponentHeader from "../commoncomponents/ComponentHeader";
import ScmBottomButtonsforWorkOrder from "./ScmBottomButtonsforWorkOrder";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import { useDispatch, useSelector } from "react-redux";
import CustomDateTimePicker from "../commoncomponents/CustomDateTimePicker";
import { updateAssessmentsPartsInitialState, updateAssessmentsPartsRequired, updateBasicDetailsWorkOrder, updateOutsourceDetails, updateWorkOrderStatus } from "../../redux/actions/ScmActionTypes";
import { getAuthToken, getCreatedBy, getFacilityId } from "../../utility/tokenUtility";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import PageLoader from "../commoncomponents/PageLoader";
import ScmRepositry from "../../api/repositories/scmRepository";
import { mandatoryFields } from "../../redux/actions/assetActions";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import { processingPercentageValue, statusList } from "../../utility/message";
import workOrderSummaryRepositry from "../../api/repositories/workOrderSummaryRepositries";
import { v4 as uuidv4 } from 'uuid';

export const CancelWorkOrder = ({ open, onClose, onConfirm }) => {
    const [value, setValue] = useState({
        cancelledBy: "",
        reasonforCancellation: "",
    });

    const [errors, setErrors] = useState({
        cancelledBy: false,
        reasonforCancellation: false,
    });

    const [errorMessage, setErrorMessage] = useState({
        cancelledBy: "",
        reasonforCancellation: "",
    });

    const handleChange = (value, name) => {
        setValue((previous) => ({
            ...previous,
            [name]: value,
        }));

        if (value.trim() !== "") {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: false,
            }));

            setErrorMessage((prevMessages) => ({
                ...prevMessages,
                [name]: "",
            }));
        }
    };

    const handleConfirm = () => {
        const newErrors = {
            cancelledBy: value.cancelledBy.trim() === "",
            reasonforCancellation: value.reasonforCancellation.trim() === "",
        };

        const newErrorMessages = {
            cancelledBy: value.cancelledBy.trim() === "" ? "Cancelled By is required" : "",
            reasonforCancellation: value.reasonforCancellation.trim() === "" ? "Reason for Cancellation is required" : "",
        };

        setErrors(newErrors);
        setErrorMessage(newErrorMessages);

        const isValid = !newErrors.cancelledBy && !newErrors.reasonforCancellation;

        if (isValid) {
            onConfirm(value);
            onClose('yes');
        }
    };

    const handleClose = () => {
        onClose('no');
        setValue({
            cancelledBy: "",
            reasonforCancellation: "",
        });

        setErrorMessage({
            cancelledBy: "",
            reasonforCancellation: "",
        });

        setErrors({
            cancelledBy: false,
            reasonforCancellation: false,
        });

    };

    useEffect(() => {
        if (open) {
            setErrors({
                cancelledBy: false,
                reasonforCancellation: false,
            });
            setErrorMessage({
                cancelledBy: "",
                reasonforCancellation: "",
            });
            setValue({
                cancelledBy: "",
                reasonforCancellation: "",
            })
        }
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Cancel WorkOrder</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={6} md={6}>
                        <CustomTextField
                            label="Cancelled By"
                            id="cancelledBy"
                            name='cancelledBy'
                            value={value?.cancelledBy}
                            onChange={(e) => handleChange(e, 'cancelledBy')}
                            isMandatoryField={true}
                            error={errors.cancelledBy}
                            errorMessage={errorMessage.cancelledBy}
                        />
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <CustomTextField
                            label="Reason for Cancellation"
                            id="reasonforCancellation"
                            name="reasonforCancellation"
                            value={value?.reasonforCancellation}
                            onChange={(e) => handleChange(e, 'reasonforCancellation')}
                            isMandatoryField={true}
                            error={errors.reasonforCancellation}
                            errorMessage={errorMessage.reasonforCancellation}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">No</Button>
                <Button onClick={handleConfirm} color="error">Yes</Button>
            </DialogActions>
        </Dialog>
    );
};


const ScmBasicDetails = ({ setPage, page, buttonAttributes }) => {

    const findHeaderContent = buttonAttributes.find(
        (item) => item.currentPageName === page
    );
    const location = useLocation();
    const editServiceType = location.state?.service;
    const viewmode = location.state?.viewmode;
    const editmode = location.state?.editmode;
    const dispatch = useDispatch();
    const basicDetails = useSelector((state) => state.scmBasicDetails);
    const mandatoryBasicDetails = useSelector((state) => state.scmMandatoryFields.mandatoryFieldsBasicDetails);
    const assetCategoryType = useSelector((state) => state?.serviceType);
    const getStepper = useSelector((state) => state?.checkParts);
    const facilityId = getFacilityId('facilityId');
    const token = getAuthToken("id_token");
    const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
    const status = useSelector((state) => state?.workOrderStatus?.status);
    const processingPercentage = useSelector((state) => state?.workOrderStatus?.percentage);
    const checkcancelWOStatus = status === "Open" || status === "In Progress" || status === "Cancelled" || status === "In Progress-Outsource" ? true : false;
    let scheduledWorkorderDetails = {};


    const [basicDetailsdata, setBasicDetailsData] = useState(basicDetails || {});
    const [enable, setEnable] = useState(false);
    const [loading, setLoading] = useState(true);
    const [errorDialog,setErrorDialog] = useState(false);
    const [errorDialogMssg,setErrorDialogMssg] = useState("");
    const [error, setError] = useState({
        referenceWorkOrderNo: false,
        requestDetails: false,
        recivedDateandTime: false
    });
    const [errorMessage, setErrorMessage] = useState({
        referenceWorkOrderNo: "",
        requestDetails: "",
        recivedDateandTime: ""
    });
    const [basicDetailsOptions, setBasicDetailsOptions] = useState(
        {
            workOrderNo: [],
            referenceType: [],
        }
    );

    const statusMapping = {
        "Open": 1,
        "In Progress": 3,
        "Completed": 4,
        "Closed": 5,
        "Cancelled": 6,
        "Verified": 8,
        "Not Done and Closed":7,
        "Completed-Outsource":9,
        "In Progress-Outsource":10
    };

    // Map the current status to the corresponding number
    const mappedStatus = statusMapping[status] || null; // If status doesn't exist, fallback to null or any default value
    const serviceName = basicDetailsdata?.referenceWorkOrderNo?.serviceName === "FEMS" ? "fem" : "bem"

    const handleOnchange = (value, name,errorStateName) => {

        if (name === "requestDetails") {
            if (value?.startsWith(" ")) {
                setError((prev) => ({
                    ...prev,
                    [name]: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: `${errorStateName} should not start with spaces`,
                }));
                return;
            } else if (value?.endsWith("  ")) {
                setError((prev) => ({
                    ...prev,
                    [name]: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: `${errorStateName} should not end with spaces`,
                }));
                return;
            } else {
                setError((prev) => ({
                    ...prev,
                    [name]: false,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: "",
                }));
            }
        }

        setBasicDetailsData((previous) => {
            const updatedData = {
                ...previous,
                [name]: value,
            };
            
            if (name === "referenceWorkOrderNo" && value?.id) {
                updatedData.referenceWorkOrderNo = { ...value, label: value?.label ? value?.label : '' };
                updatedData.assetNo = value?.assetNo;
                updatedData.assetId = value?.assetId;
                updatedData.oldAssetNo = value?.oldAssetNo;
                updatedData.underwarrenty = value?.underwarrenty;
                updatedData.description = value?.assetdesc;
                updatedData.location = value?.location;
                updatedData.workGroupId = value?.workGroupId;
                updatedData.workgroupDescription = value?.workGroupcodeDesc;
                updatedData.requestDetails = value?.requestDetails;
                if (value?.id) {
                    getWorkorderDetails(value?.id, value?.serviceName);
                    setError((prev) => {
                        return {
                            ...prev,
                            requestDetails: false
                        }
                    });
                    setErrorMessage((prev) => {
                        return {
                            ...prev,
                            requestDetails: ""
                        }
                    });
                };

            } else if (name === "referenceWorkOrderNo") {
                updatedData.referenceWorkRequestNo = "";
                updatedData.issueDateandTimeBasicDetails = "";
                updatedData.assetNo = "";
                updatedData.assetId = "";
                updatedData.oldAssetNo = "";
                updatedData.underwarrenty = "";
                updatedData.description = "";
                updatedData.location = "";
                updatedData.workGroupId = "";
                updatedData.workgroupDescription = "";
                updatedData.requestDetails = "";
            };
            return updatedData;
        });

        const workOrderDateAndTime = basicDetailsdata?.workorderDateandTime || basicDetails?.workorderDateandTime;

        if (name === 'recivedDateandTime' && value && workOrderDateAndTime) {
            const workOrderDate = new Date(workOrderDateAndTime);
            const selectedDate = new Date(value);

            // Allow if selectedDate is the same or greater than workOrderDate
            if (selectedDate.getTime() < workOrderDate.getTime()) {
                setError((prev) => ({
                    ...prev,
                    recivedDateandTime: true
                }));

                setErrorMessage((prev) => ({
                    ...prev,
                    recivedDateandTime: "Received Start date and time should be greater than or equal to the work order date and time."
                }));
                return;
            } else {
                setError((prev) => ({
                    ...prev,
                    recivedDateandTime: false
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    recivedDateandTime: ""
                }));
            }
        }

        setError((prev) => {
            const updatedError = {
                ...prev,
                [name]: false
            };
            return updatedError;
        });

        setErrorMessage((prev) => ({
            ...prev,
            [name]: ''
        }));

    };

    const memoizedDetails = useMemo(() => ({
        referenceWorkOrderNo: basicDetailsdata?.referenceWorkOrderNo || '',
        requestDetails: basicDetailsdata?.requestDetails || '',
        recivedDateandTime: basicDetailsdata?.recivedDateandTime || '',
    }), [
        basicDetailsdata?.referenceWorkOrderNo,
        basicDetailsdata?.requestDetails,
        basicDetailsdata?.recivedDateandTime,
    ]);

    //function to check the mandatory field are filled or not(responsible for green ticks on left side)
    const checkMandatoryValueFilled = useCallback(debounce((
        referenceWorkOrderNo,
        requestDetails,
        recivedDateandTime
    ) => {
        const updateStatus = (type, value, name, isVisible, errorState) => ({
            type,
            valueFilled: !errorState && !!value,
            name,
            isVisible
        });
        // const updateWorkOrderNo = updateStatus("Reference PPM/RI Work Order No", referenceWorkOrderNo, 'referenceWorkOrderNo', true, error?.referenceWorkOrderNo);
        const updateWorkOrderNo = updateStatus("Reference PPM Work Order No", referenceWorkOrderNo, 'referenceWorkOrderNo', true, error?.referenceWorkOrderNo);
        const updaterequestDetails = updateStatus("Request Details", requestDetails, 'requestDetails', true, error?.requestDetails);
        const updateDateandTimeBasicDetails = updateStatus("Received Date & Time", recivedDateandTime, 'recivedDateandTime', true, error?.recivedDateandTime);

        const arrayAfterUpdating = [
            updateWorkOrderNo,
            updaterequestDetails,
            updateDateandTimeBasicDetails,
        ];


        if (arrayAfterUpdating !== undefined && arrayAfterUpdating.every(item => item !== undefined)) {
            dispatch({ type: "UPDATE_WORK_ORDER_BASIC_DETAILS_MANDATORY_FIELDS", payload: arrayAfterUpdating })
        };
    }), [dispatch, error]);

    useEffect(() => {
        const {
            referenceWorkOrderNo,
            requestDetails,
            recivedDateandTime
        } = memoizedDetails;
        checkMandatoryValueFilled(
            referenceWorkOrderNo?.label,
            requestDetails?.trim(),
            recivedDateandTime
        );
    }, [
        memoizedDetails,
        checkMandatoryValueFilled
    ], []);

    const handleValidationForRequiredFields = () => {
        let isValid = true;
        mandatoryBasicDetails.map((item) => {
            if (item.valueFilled === false) {
                setError((prev) => ({
                    ...prev,
                    [item.name]: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [item?.name]: prev[item?.name] || `${item.type} is required `,
                }));
                isValid = false;
            }
        });
        return isValid;
    };
    
    const workOrderNoOptions = async () => {
        const workOrderNo = await ScmRepositry.fetchWorkOrderNo();
        setBasicDetailsOptions((prevOptions) => ({
            ...prevOptions,
            workOrderNo: workOrderNo?.map((item, index) => {
                return {
                    key: `option${index}`,
                    id: item?.workorderId || "",
                    label: item?.workorderno || "",
                    assetNo: item?.assetNo || "",
                    location: item?.locationName || "",
                    underwarrenty: item?.isunderwarranty === true ? "Yes" : item?.isunderwarranty === false ? "No" : "",
                    assetdesc: item?.assetDesc || "",
                    assetId: item?.assetid || "",
                    workGroupId: item?.groupId || "",
                    workGroupcodeDesc: `${item?.groupcode} - ${item?.groupdesc}` || "",
                    oldAssetNo: item?.oldassetno || "",
                    requestDetails: item?.requestdetails || "",
                    serviceId: item?.serviceId || "",
                    serviceName: item?.service || "",
                    workOrderDateAndTime: item?.workorderdate || "",
                };
            })
        }));

    };

    const referenceTypeOptions = () => {
        setBasicDetailsOptions((prevOptions) => ({
            ...prevOptions,
            referenceType: [
                { label: "PPM", value: "PPM", id: 1 },
              //  { label: "RI", value: "RI", id: 2 },
            ]

        }));

    };

    useEffect(() => {
        dispatch({
            type: "SERVICE&CATEGORY_TYPE", payload: {
                assetType: editServiceType ? editServiceType : serviceName
            }
        })

    }, [basicDetailsdata?.referenceWorkOrderNo, editServiceType]);


    const fetchData = async () => {
        try {
            if (location?.state?.id) {

                const response = await ScmRepositry.getWorkOrderSummary(editServiceType, location.state.id);

                if (editServiceType === 'fem') {
                    const data = response?.[0];
                    const status = data?.femschcorrectivemaintenanceheaders?.[0]?.femworkorderstatus?.workorderstatus || "";
                    const percentageStatus = data?.femschcorrectivemaintenanceheaders?.[0]?.processingpercentage || "";
                    dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: status, percentage: percentageStatus }))

                    const setService = editServiceType === 'fem' ? "FEMS" : "BEMS";
                    const CreateModeResponse = await getWorkorderDetails(data?.workOrderId,setService);                    

                    const employeeResponse = await ScmRepositry.fetchEmployeeDetails();
                    const lovOptionsResponse = await ScmRepositry.lovOptions();
                    const vendorDetails = await ScmRepositry.fetchVendorDetails();

                    const maptoVendorDetails = (id) => {
                        const vendor = vendorDetails?.find(v => v?.id === id);
                        return vendor ? vendor?.vendorname : '';
                    };

                    const maptoVendorCode = (id) => {
                        const vendor = vendorDetails?.find(v => v?.id === id);
                        return vendor ? vendor?.vendorcode : '';
                    };

                    const mapEmployeeIdToName = (id) => {
                        const employee = employeeResponse?.find(emp => emp?.id === id);
                        return employee ? employee.employeename : '';
                    };

                    const mapEmployeeIdToCode = (id) => {
                        const employee = employeeResponse?.find(emp => emp?.id === id);
                        return employee ? employee?.employeecode : '';
                    };

                    const mapFlagIdToLabel = (id) => {
                        const flag = lovOptionsResponse?.femuschworepairflags?.find(f => f?.id === id);
                        return flag ? flag?.repairflag : '';
                    };

                    const mapPicIdToLabel = (id) => {
                        const pic = lovOptionsResponse?.femuschworepairpics?.find(p => p?.id === id);
                        return pic ? pic?.repairpic : '';
                    };

                    const mapActivityIdToLabel = (id) => {
                        const activity = lovOptionsResponse?.femuschworepairactivities?.find(a => a?.id === id);
                        return activity ? activity?.repairactivity : '';
                    };

                    // Mapping repairTracker data
                    const repairDetails  = data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.femschcorrectiverepairdetails;
                    let repairTracker = [];

                    if (Array.isArray(repairDetails) && repairDetails.length > 0) {
                        repairTracker = repairDetails.map((repairDetail) => ({
                        employeename: {
                            id: repairDetail?.employeeid || "",
                            employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                            employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
                        },
                        flag: {
                            id: repairDetail?.femuschworepairflagId || '',
                            label: mapFlagIdToLabel(repairDetail?.femuschworepairflagId) || ''
                        },
                        pic: {
                            id: repairDetail?.femuschworepairpicId || '',
                            label: mapPicIdToLabel(repairDetail?.femuschworepairpicId) || ''
                        },
                        activity: {
                            id: repairDetail?.femuschworepairactivityId || '',
                            label: mapActivityIdToLabel(repairDetail?.femuschworepairactivityId) || ''
                        },
                        technician: repairDetail?.technician || repairDetail?.vendortechnician || "",
                        startDateandTime: repairDetail?.repairstartdate || "",
                        endDateandTime: repairDetail?.repairenddate || "",
                        repairDuration: repairDetail?.repairduration || "",
                        remarks: repairDetail?.remarks || '',
                        preparationHours: repairDetail?.preparationhours || '',
                        verificationHours: repairDetail?.verificationhours || '',
                        id: repairDetail?.id || ""
                    }));
                    } else {
                        repairTracker = CreateModeResponse?.assessments?.repairTracker || [];
                    }

                    const itemCodeResponse = await ScmRepositry.fetchItemCodeoptions(serviceType);
                    
                    const mapItemCode = (id) => {                        
                        const ic = itemCodeResponse?.find(ic => ic?.id === id);
                        return ic ? ic.itemcode : '';
                    };
                    const mapItemDesc = (id) => {
                        const ic = itemCodeResponse?.find(ic => ic?.id === id);
                        return ic ? ic?.descriptionname : '';
                    };

                    // Mapping Part Replacements data
                    const partReplacementdetails = data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivepartsreplacedetails;                    
                    let partReplacement = [];
                    if (Array.isArray(partReplacementdetails) && partReplacementdetails.length > 0) {
                        partReplacement = partReplacementdetails.map((partDetails) => ({
                            itemPartCode: {
                                id: partDetails?.itemcodeid || "",
                                label: mapItemCode(partDetails?.itemcodeid) || "",
                            },
                            itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
                            quantity: partDetails?.quantityused || "",
                            partCost: parseFloat(partDetails?.partscost || 0)?.toFixed(2) || "",
                            id: partDetails?.itemcodeid || "",
                            editmode: true

                        }));
                    } else {
                        partReplacement = CreateModeResponse?.partReplacementRows || [];
                    }

                    const refworkreq = {
                        id: data?.workOrderId || "",
                        label: data?.workorderno || "",
                        workGroupId: data?.wgId || ""
                    };

                    const respondedBy = {
                        id: data?.assessmentEmployeeId || CreateModeResponse?.assessments?.respondedBy?.id || "",
                        label: data?.assessmentEmployeename || CreateModeResponse?.assessments?.respondedBy?.label || ""
                    };

                    const taskcode = {
                        id: data?.taskcodeId || CreateModeResponse?.assessments?.taskCode?.id || "",
                        label: data?.taskcode || CreateModeResponse?.assessments?.taskCode?.label || ""
                    };

                    const vendor = {
                        id: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.vendorid || CreateModeResponse?.assessments?.vendor?.id || "",
                        label: maptoVendorDetails(data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.vendorid) || CreateModeResponse?.assessments?.vendor?.label || "",
                        vendorcode: maptoVendorCode(data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.vendorid || CreateModeResponse?.assessments?.vendor?.vendorcode ) || ""
                    };

                    const isPartsRequired = data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.ispartsrequired;
                    const scheduledWorkorderPartsRequired = CreateModeResponse?.assessments?.partsRequired?.id;

                    let partsRequired = { id: "", label: "" };

                    if (isPartsRequired === true || scheduledWorkorderPartsRequired === 1 || scheduledWorkorderPartsRequired === "") {
                        partsRequired = { id: 1, label: "Yes" };
                    } else if (isPartsRequired === false || scheduledWorkorderPartsRequired === 2) {
                        partsRequired = { id: 2, label: "No" };
                    }

                    const withPartsRequired = getStepper;
                    const withoutPartsRequired = getStepper?.filter((item) => item?.label !== 'Part Replacement');

                    if (partsRequired?.label === 'Yes' || partsRequired?.label === "" || CreateModeResponse?.assessments?.partsRequired?.label === "Yes" || CreateModeResponse?.assessments?.partsRequired?.label === "") {
                        dispatch(updateAssessmentsPartsInitialState("UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE", withPartsRequired));
                    } else {
                        dispatch(updateAssessmentsPartsRequired("UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED", withoutPartsRequired));
                    };

                    const isAssettakenLocation = data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.isassettakenoutlocation;
                    const scheduledAssetTAkenLocation = CreateModeResponse?.assessments?.assetTakenLocation;

                    let assetTakenLocation = { id: "", label: "" };

                    if(isAssettakenLocation === true || scheduledAssetTAkenLocation === 1) {
                        assetTakenLocation = { id: 1, label: "Yes" };
                    } else if(isAssettakenLocation === false || scheduledAssetTAkenLocation === 2) {
                        assetTakenLocation = { id: 2, label: "No" };
                    }

                    const referenceType = {
                        id: data?.femschcorrectivemaintenanceheaders?.[0]?.femscmreferencetypes?.id || "",
                        label: data?.femschcorrectivemaintenanceheaders?.[0]?.femscmreferencetypes?.referencetype || ""
                    }

                    const mappedData = {
                        workorderId: data?.workOrderId || "",
                        id: location.state?.id || "",
                        referenceType: referenceType,
                        serviceType: 'FEMS',
                        schcorrectiveno: data?.femschcorrectivemaintenanceheaders?.[0]?.schcorrectiveno || '',
                        referenceWorkOrderNo: refworkreq || "",
                        issueDateandTimeBasicDetails: data?.femschcorrectivemaintenanceheaders?.[0]?.targetdate || "",
                        workorderDateandTime: data?.workorderdate || "",
                        assetId: data?.assetId || "",
                        assetNo: data?.assetNo || "",
                        oldAssetNo: data?.femschcorrectivemaintenanceheaders?.[0]?.femassetregister?.oldassetno || '',
                        description: data?.assetDescription || '',
                        underwarrenty: data?.femschcorrectivemaintenanceheaders?.[0]?.femassetregister?.isunderwarranty === true
                            ? "Yes"
                            : data?.femschcorrectivemaintenanceheaders?.[0]?.femassetregister?.isunderwarranty === false
                                ? "No"
                                : '',
                        location: data?.locationdesc || '',
                        workgroupDescription:`${data?.workGroup || ''}${(data?.workGroup && data?.wgdesc) ? " - " : ""}${data?.wgdesc || ''}` || '',
                        requestDetails: data?.femschcorrectivemaintenanceheaders?.[0]?.requestdetails || '',
                        recivedDateandTime: data?.femschcorrectivemaintenanceheaders?.[0]?.receiveddate ||  "",
                        cancelledBy: data?.femschcorrectivemaintenanceheaders?.[0]?.cancelledby || '',
                        reasonforCancellation: data?.femschcorrectivemaintenanceheaders?.[0]?.cancellationreason || '',
                        ppmscheduletrackId: data?.femschcorrectivemaintenanceheaders?.[0]?.femscheduledworkorderheader?.femppmscheduletrackId || "",
                        completionInfo: {
                            id: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.id || '',
                            respondedBy: {
                                id: data?.completionEmployeeId || CreateModeResponse?.completionInfo?.respondedBy?.id || '',
                                label: data?.completionEmployeename || CreateModeResponse?.completionInfo?.respondedBy?.label || '',
                                designation: data?.completionDesignation || CreateModeResponse?.completionInfo?.respondedBy?.designation || "",
                                value: data?.completionEmployeename || CreateModeResponse?.completionInfo?.respondedBy?.label || ''
                            } ,
                            designation: data?.completionDesignation || CreateModeResponse?.completionInfo.designation || "",
                            respondedDateandTime: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.responsestartdate || CreateModeResponse?.completionInfo?.respondedDateandTime || "",
                            duration: data?.duration || CreateModeResponse?.completionInfo?.duration || '',
                            completionBy: {
                                id: data?.completionByEmployeeId || CreateModeResponse?.completionInfo?.completionBy?.id || '',
                                label: data?.completionByEmployeename || CreateModeResponse?.completionInfo?.completionBy?.label || '',
                                value: data?.completionByEmployeename || CreateModeResponse?.completionInfo?.completionBy?.value ||''
                            },
                            startDateandTime: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.startdate || CreateModeResponse?.completionInfo?.startDateandTime || '',
                            endDateandTime: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.enddate || CreateModeResponse?.completionInfo?.endDateandTime ||'',
                            actionTaken: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.actiontaken || CreateModeResponse?.completionInfo?.actionTaken || '',
                            signatureFiles: [],
                            costInfo: {
                                editmode: true,
                                breakDownCost: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : (CreateModeResponse?.completionInfo?.costInfo?.breakDownCost || 0),
                                poNumber: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.breakdowncostpurorderno || CreateModeResponse?.completionInfo?.costInfo?.poNumber || '',
                                ppmCostByPurchaseOrder: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.ppmcost ? parseFloat(data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : (CreateModeResponse?.completionInfo?.costInfo?.ppmCostByPurchaseOrder || 0),
                                poNumberByPurchaseOrder: data?.bemschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.ppmcostpurorderno || CreateModeResponse?.completionInfo?.costInfo?.poNumberByPurchaseOrder ||'',
                                ppmCostByContract: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : (CreateModeResponse?.completionInfo?.costInfo?.ppmCostByContract || 0),
                                contractReferenceNumber: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.contractrefno ||  CreateModeResponse?.completionInfo?.costInfo?.contractReferenceNumber ||'',
                                totalSparePartCost: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.sparepartscost ? parseFloat(data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.sparepartscost || 0)?.toFixed(2) : (CreateModeResponse?.completionInfo?.costInfo?.totalSparePartCost || 0),
                                totalWorkorderCost: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.totalwocost ? parseFloat(data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.totalwocost || 0)?.toFixed(2) : (CreateModeResponse?.completionInfo?.costInfo?.totalWorkorderCost || 0)
                            }
                        },
                        assessments: {
                            id: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.id || '',
                            respondedBy: respondedBy || '',
                            respondedStartDateandTime: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.responsestartdate || data?.workorderdate || "",
                            respondedEndDateandTime: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.responseenddate || '',
                            taskCode: taskcode || '',
                            taskDescription: data?.taskdesc || CreateModeResponse?.assessments?.taskDescription || '',
                            repairType: data?.femworespondtype || CreateModeResponse?.assessments?.repairType || '',
                            partsRequired: partsRequired || '',
                            assetTakenLocation: assetTakenLocation || '',
                            respondedFinding: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.respondfinding || CreateModeResponse?.assessments?.respondedFinding || '',
                            repairTracker: repairTracker || [],
                            designation: data?.assessmentDesignation || CreateModeResponse?.assessments?.designation || "",
                            vendor:vendor || "",
                            outsourceRespondRemarks: data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectiveassessmentheaders?.[0]?.respondremarks || CreateModeResponse?.assessments?.outsourceRespondRemarks || "",
                        },
                        partReplacementRows: partReplacement || [],
                        authorizedbyid:data?.femschcorrectivemaintenanceheaders?.[0]?.femschcorrectivecompletiondetails?.[0]?.authorizedbyid || "",
                        Authorizedby: data?.authorizedby || "",
                        AuthorizedbyDate: data?.authorizedbyDate || "",
                    };

                    const setvendorField = data?.femworespondtype === 'Outsource' ? true : false;
                    setBasicDetailsData((prev) => ({
                        ...prev,
                        ...mappedData
                    }));
                    dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...mappedData }));
                    dispatch(updateOutsourceDetails("SET_VENDORFIELD", setvendorField));

                } else {
                    const data = response?.[0];
                    const status = data?.bemschcorrectivemaintenanceheaders?.[0]?.bemworkorderstatus?.workorderstatus || "";
                    const percentageStatus = data?.bemschcorrectivemaintenanceheaders?.[0]?.processingpercentage || "";
                    dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: status, percentage: percentageStatus }))

                    const setService = editServiceType === 'fem' ? "FEMS" : "BEMS";
                    const CreateModeResponse = await getWorkorderDetails(data?.workOrderId,setService);                    

                    const employeeResponse = await ScmRepositry.fetchEmployeeDetails();
                    const lovOptionsResponse = await ScmRepositry.lovOptions();
                    const vendorDetails = await ScmRepositry.fetchVendorDetails();

                    const maptoVendorDetails = (id) => {
                        const vendor = vendorDetails?.find(v => v?.id === id);
                        return vendor ? vendor?.vendorname : '';
                    };

                    const maptoVendorCode = (id) => {
                        const vendor = vendorDetails?.find(v => v?.id === id);
                        return vendor ? vendor?.vendorcode : '';
                    };

                    const mapEmployeeIdToName = (id) => {
                        const employee = employeeResponse?.find(emp => emp?.id === id);
                        return employee ? employee.employeename : '';
                    };

                    const mapEmployeeIdToCode = (id) => {
                        const employee = employeeResponse?.find(emp => emp?.id === id);
                        return employee ? employee?.employeecode : '';
                    };

                    const mapFlagIdToLabel = (id) => {
                        const flag = lovOptionsResponse?.femuschworepairflags?.find(f => f?.id === id);
                        return flag ? flag?.repairflag : '';
                    };

                    const mapPicIdToLabel = (id) => {
                        const pic = lovOptionsResponse?.femuschworepairpics?.find(p => p?.id === id);
                        return pic ? pic?.repairpic : '';
                    };

                    const mapActivityIdToLabel = (id) => {
                        const activity = lovOptionsResponse?.femuschworepairactivities?.find(a => a?.id === id);
                        return activity ? activity?.repairactivity : '';
                    };

                    // Mapping repairTracker data
                    const repairDetails = data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.bemschcorrectiverepairdetails;
                    let repairTracker = [];
                    if (Array.isArray(repairDetails) && repairDetails.length > 0) {
                        repairTracker = repairDetails.map((repairDetail) => ({
                            employeename: {
                                id: repairDetail?.employeeid || "",
                                employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                                employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
                            },
                            flag: {
                                id: repairDetail?.bemuschworepairflagId || '',
                                label: mapFlagIdToLabel(repairDetail?.bemuschworepairflagId) || ''
                            },
                            pic: {
                                id: repairDetail?.bemuschworepairpicId || '',
                                label: mapPicIdToLabel(repairDetail?.bemuschworepairpicId) || ''
                            },
                            activity: {
                                id: repairDetail.bemuschworepairactivityId || '',
                                label: mapActivityIdToLabel(repairDetail?.bemuschworepairactivityId) || ''
                            },
                            technician: repairDetail?.technician || repairDetail?.vendortechnician || "",
                            startDateandTime: repairDetail?.repairstartdate || "",
                            endDateandTime: repairDetail?.repairenddate || "",
                            repairDuration: repairDetail?.repairduration || "",
                            remarks: repairDetail?.remarks || '',
                            preparationHours: repairDetail?.preparationhours || '',
                            verificationHours: repairDetail?.verificationhours || '',
                            id: repairDetail?.id || ""
                        }));
                    } else {
                            repairTracker = CreateModeResponse?.assessments?.repairTracker || [];
                        }
                    
                    const itemCodeResponse = await ScmRepositry.fetchItemCodeoptions(serviceType);
                    const mapItemCode = (id) => {
                        const ic = itemCodeResponse?.find(ic => ic?.id === id);
                        return ic ? ic.itemcode : '';
                    };
                    const mapItemDesc = (id) => {
                        const ic = itemCodeResponse?.find(ic => ic?.id === id);
                        return ic ? ic?.descriptionname : '';
                    };

                    // Mapping Part Replacements data
                    const partReplacementdetails = data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivepartsreplacedetails;
                    let partReplacement = [];
                    if (Array.isArray(partReplacementdetails) && partReplacementdetails.length > 0) {
                        partReplacement = partReplacementdetails.map((partDetails) => ({
                            itemPartCode: {
                                id: partDetails?.id || "",
                                label: mapItemCode(partDetails?.itemcodeid) || "",
                            },
                            itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
                            quantity: partDetails?.quantityused || "",
                            partCost: partDetails?.partscost || "",
                            id: partDetails?.itemcodeid || "",
                            editmode: true
                        }));
                    } else {
                        partReplacement = CreateModeResponse?.partReplacementRows || [];

                    }

                    const refworkreq = {
                        id: data?.workOrderId || "",
                        label: data?.workorderno || "",
                        workGroupId: data?.wgId || ""
                    };

                    const respondedBy = {
                        id: data?.assessmentEmployeeId || CreateModeResponse?.assessments?.respondedBy?.id || "",
                        label: data?.assessmentEmployeename || CreateModeResponse?.assessments?.respondedBy?.label || ""
                    };

                    const taskcode = {
                        id: data?.taskcodeId || CreateModeResponse?.assessments?.taskCode?.id || "",
                        label: data?.taskcode || CreateModeResponse?.assessments?.taskCode?.label || ""
                    };

                    const vendor = {
                        id: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.vendorid || CreateModeResponse?.assessments?.vendor?.id || "",
                        label: maptoVendorDetails(data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.vendorid) || CreateModeResponse?.assessments?.vendor?.label || "",
                        vendorcode: maptoVendorCode(data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.vendorid || CreateModeResponse?.assessments?.vendor?.vendorcode ) || ""
                    };

                    const isPartsRequired = data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.ispartsrequired
                    const scheduledWorkorderPartsRequired = CreateModeResponse?.assessments?.partsRequired?.id;
                    let partsRequired = { id: "", label: "" };

                    if (isPartsRequired === true || scheduledWorkorderPartsRequired === 1 || scheduledWorkorderPartsRequired === "") {
                        partsRequired = { id: 1, label: "Yes" };
                    } else if (isPartsRequired === false || scheduledWorkorderPartsRequired === 2) {
                        partsRequired = { id: 2, label: "No" };
                    }

                    const withPartsRequired = getStepper;
                    const withoutPartsRequired = getStepper?.filter((item) => item?.label !== 'Part Replacement');

                    if (partsRequired?.label === 'Yes' || partsRequired?.label === "" || CreateModeResponse?.assessments?.partsRequired?.label === "Yes" || CreateModeResponse?.assessments?.partsRequired?.label === "") {
                        dispatch(updateAssessmentsPartsInitialState("UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE", withPartsRequired));
                    } else {
                        dispatch(updateAssessmentsPartsRequired("UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED", withoutPartsRequired));
                    };

                    const isAssettakenLocation = data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.isassettakenoutlocation
                    const scheduledAssetTAkenLocation = CreateModeResponse?.assessments?.assetTakenLocation;

                    let assetTakenLocation = { id: "", label: "" };

                    if(isAssettakenLocation === true || scheduledAssetTAkenLocation === 1) {
                        assetTakenLocation = { id: 1, label: "Yes" };
                    } else if(isAssettakenLocation === false || scheduledAssetTAkenLocation === 2) {
                        assetTakenLocation = { id: 2, label: "No" };
                    }

                    const referenceType = {
                        id: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemscmreferencetypes?.id || "",
                        label: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemscmreferencetypes?.referencetype || ""
                    };

                    const mappedData = {
                        workorderId: data?.workOrderId || "",
                        id: location.state?.id || "",
                        referenceType: referenceType,
                        serviceType: 'BEMS',
                        schcorrectiveno: data?.bemschcorrectivemaintenanceheaders?.[0]?.schcorrectiveno || '',
                        referenceWorkOrderNo: refworkreq || "",
                        issueDateandTimeBasicDetails: data?.bemschcorrectivemaintenanceheaders?.[0]?.targetdate || "",
                        workorderDateandTime: data?.workorderdate || "",
                        assetId: data?.assetId || "",
                        assetNo: data?.assetNo || "",
                        oldAssetNo: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemassetregister?.oldassetno || '',
                        description: data?.assetDescription || '',
                        underwarrenty: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemassetregister?.isunderwarranty === true
                            ? "Yes"
                            : data?.bemschcorrectivemaintenanceheaders?.[0]?.bemassetregister?.isunderwarranty === false
                                ? "No"
                                : '',
                        location: data?.locationdesc || '',
                        workgroupDescription:`${data?.workGroup || ''}${(data?.workGroup && data?.wgdesc) ? " - " : ""}${data?.wgdesc || ''}` || '',
                        requestDetails: data?.bemschcorrectivemaintenanceheaders?.[0]?.requestdetails || '',
                        recivedDateandTime: data?.bemschcorrectivemaintenanceheaders?.[0]?.receiveddate || "",
                        cancelledBy: data?.bemschcorrectivemaintenanceheaders?.[0]?.cancelledby || '',
                        reasonforCancellation: data?.bemschcorrectivemaintenanceheaders?.[0]?.cancellationreason || '',
                        ppmscheduletrackId: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemscheduledworkorderheader?.bemppmscheduletrackId || "",
                        completionInfo: {
                            id: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.id || '',
                            respondedBy: {
                                id: data?.completionEmployeeId || CreateModeResponse?.completionInfo?.respondedBy?.id || '',
                                label: data?.completionEmployeename || CreateModeResponse?.completionInfo?.respondedBy?.label || '',
                                designation: data?.completionDesignation || CreateModeResponse?.completionInfo?.respondedBy?.designation || "",
                                value: data?.completionEmployeename || CreateModeResponse?.completionInfo?.respondedBy?.label || ''
                            },
                            designation: data?.completionDesignation || CreateModeResponse?.completionInfo.designation || "",
                            respondedDateandTime: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.responsestartdate || CreateModeResponse?.completionInfo?.respondedDateandTime || "",
                            duration: data?.duration || CreateModeResponse?.completionInfo?.duration || '',
                            completionBy: {
                                id: data?.completionByEmployeeId || CreateModeResponse?.completionInfo?.completionBy?.id || '',
                                label: data?.completionByEmployeename || CreateModeResponse?.completionInfo?.completionBy?.label || '',
                                value: data?.completionByEmployeename || CreateModeResponse?.completionInfo?.completionBy?.value || ''
                            },
                            startDateandTime: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.startdate || CreateModeResponse?.completionInfo?.startDateandTime || '',
                            endDateandTime: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.enddate || CreateModeResponse?.completionInfo?.endDateandTime ||'',
                            actionTaken: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.actiontaken || CreateModeResponse?.completionInfo?.actionTaken || '',
                            signatureFiles: [],
                            costInfo: {
                                editmode: true,
                                breakDownCost: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : (CreateModeResponse?.completionInfo?.costInfo?.breakDownCost || 0),
                                poNumber: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.breakdowncostpurorderno || CreateModeResponse?.completionInfo?.costInfo?.poNumber || '',
                                ppmCostByPurchaseOrder: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.ppmcost ? parseFloat(data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : (CreateModeResponse?.completionInfo?.costInfo?.ppmCostByPurchaseOrder || 0),
                                poNumberByPurchaseOrder: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.ppmcostpurorderno || CreateModeResponse?.completionInfo?.costInfo?.poNumberByPurchaseOrder ||'',
                                ppmCostByContract: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : (CreateModeResponse?.completionInfo?.costInfo?.ppmCostByContract || 0),
                                contractReferenceNumber: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.contractrefno || CreateModeResponse?.completionInfo?.costInfo?.contractReferenceNumber ||'',
                                totalSparePartCost: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.sparepartscost ? parseFloat(data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.sparepartscost || 0)?.toFixed(2) : (CreateModeResponse?.completionInfo?.costInfo?.totalSparePartCost || 0),
                                totalWorkorderCost: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.totalwocost ? parseFloat(data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.totalwocost || 0)?.toFixed(2) : (CreateModeResponse?.completionInfo?.costInfo?.totalWorkorderCost || 0)
                            }
                        },
                        assessments: {
                            id: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.id || '',
                            respondedBy: respondedBy || '',
                            respondedStartDateandTime: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.responsestartdate || data?.workorderdate || "",
                            respondedEndDateandTime: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.responseenddate || '',
                            taskCode: taskcode || '',
                            taskDescription: data?.taskdesc || CreateModeResponse?.assessments?.taskDescription || '',
                            repairType: data?.bemworespondtype || CreateModeResponse?.assessments?.repairType || '',
                            partsRequired: partsRequired || '',
                            assetTakenLocation: assetTakenLocation || '',
                            respondedFinding: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.respondfinding || CreateModeResponse?.assessments?.respondedFinding || '',
                            repairTracker: repairTracker || [],
                            designation: data?.assessmentDesignation || CreateModeResponse?.assessments?.designation || "",
                            vendor:vendor || "",
                            outsourceRespondRemarks: data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectiveassessmentheaders?.[0]?.respondremarks || CreateModeResponse?.assessments?.outsourceRespondRemarks || "",
                        },
                        partReplacementRows: partReplacement,
                        authorizedbyid:data?.bemschcorrectivemaintenanceheaders?.[0]?.bemschcorrectivecompletiondetails?.[0]?.authorizedbyid || "",
                        Authorizedby: data?.authorizedby || "",
                        AuthorizedbyDate: data?.authorizedbyDate || "",
                    };

                    const setvendorField = data?.bemworespondtype === 'Outsource' ? true : false;
                    setBasicDetailsData((prev) => ({
                        ...prev,
                        ...mappedData
                    }));
                    dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...mappedData }));
                    dispatch(updateOutsourceDetails("SET_VENDORFIELD", setvendorField));
                };

            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);  // End loading after the data is fetched
        }
    };

    const getWorkorderDetails = async(scheduledWorkorderId,getService)=>{
        const workorderCategoryType = "Scheduled";
        const workordertype = "PPM"
        const serviceType = getService === "FEMS" ? "fem" : "bem";

        const response = await workOrderSummaryRepositry.getWorkOrderSummary(serviceType, scheduledWorkorderId, workorderCategoryType, workordertype);
       
                           if (serviceType === 'fem') {
                               const data = response?.[0];
                               const getRepairtype = data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype ? data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype : data?.femworespondtype || ''
                               const setvendorField = getRepairtype === 'Outsource' ? true : false;
                               dispatch(updateOutsourceDetails("SET_VENDORFIELD", setvendorField));

                               const employeeResponse = await workOrderSummaryRepositry.fetchEmployeeDetails();
                               const lovOptionsResponse = await workOrderSummaryRepositry.lovOptions();
                               const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();
                               const itemCodeResponse = await workOrderSummaryRepositry.fetchItemCodeoptions(serviceType);
       
                               const mapEmployeeIdToName = (id) => {
                                   const employee = employeeResponse?.find(emp => emp?.id === id);
                                   return employee ? employee?.employeename : '';
                               };
       
                               const mapEmployeeIdTodesignation = (id) => {
                                   const employee = employeeResponse?.find(emp => emp?.id === id);
                                   return employee ? employee?.designation : '';
                               };
       
                               const mapEmployeeIdToCode = (id) => {
                                   const employee = employeeResponse?.find(emp => emp?.id === id);
                                   return employee ? employee?.employeecode : '';
       
                               };
       
                               const maptoVendorDetails = (id) => {
                                   const vendor = vendorDetails?.find(v => v?.id === id);
                                   return vendor ? vendor?.vendorname : '';
                               };
       
                               const maptoVendorCode = (id) => {
                                   const vendor = vendorDetails?.find(v => v?.id === id);
                                   return vendor ? vendor?.vendorcode : '';
                               };
       
                               const mapFlagIdToLabel = (id) => {
                                   const flag = lovOptionsResponse?.femschworepairflags?.find(f => f?.id === id);
                                   return flag ? flag?.repairflag : '';
                               };
       
                               const mapPicIdToLabel = (id) => {
                                   const pic = lovOptionsResponse?.femschworepairpics?.find(p => p?.id === id);
                                   return pic ? pic?.repairpic : '';
                               };
       
                               const mapActivityIdToLabel = (id) => {
                                   const activity = lovOptionsResponse?.femschworepairactivities?.find(a => a?.id === id);
                                   return activity ? activity?.repairactivity : '';
                               };
       
                               const mapItemCode = (id) => {
                                   const ic = itemCodeResponse?.find(ic => ic?.id === id);
                                   return ic ? ic?.itemcode : '';
                               };
       
                               const maptoUnitCost = (id) => {
                                   const ic = itemCodeResponse?.find(ic => ic?.id === id);
                                   return ic ? ic?.unitcost : '';
                               };
       
                               const mapItemDesc = (id) => {
                                   const ic = itemCodeResponse?.find(ic => ic?.id === id);
                                   return ic ? ic.descriptionname : '';
                               };
       
                               // Mapping repairTracker data
                               const repairTracker = data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders[0]?.femscheduledworepairdetails?.map((repairDetail) => {
                              
                                   return {
                                       employeename: {
                                           id: repairDetail?.employeeid || "",
                                           employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                                           employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
                                       },
                                       flag: {
                                           id: repairDetail?.femschworepairflagId || "",
                                           label: mapFlagIdToLabel(repairDetail?.femschworepairflagId) || ""
                                       },
                                       pic: {
                                           id: repairDetail?.femschworepairpicId || "",
                                           label: mapPicIdToLabel(repairDetail?.femschworepairpicId) || ""
                                       },
                                       activity: {
                                           id: repairDetail?.femschworepairactivityId || "",
                                           label: mapActivityIdToLabel(repairDetail?.femschworepairactivityId) || ""
                                       },
                                       technician: repairDetail?.vendortechnician || "",
                                       startDateandTime: repairDetail?.repairstartdate || "",
                                       endDateandTime: repairDetail?.repairenddate || "",
                                       repairDuration: repairDetail?.repairduration || "",
                                       remarks: repairDetail?.remarks || "",
                                       preparationHours: repairDetail?.preparationhours || "",
                                       verificationHours: repairDetail?.verificationhours || "",
                                       timeStamp: repairDetail?.timestamp || "",
                                       dummy_id: uuidv4() || "",
                                   };
                               }) || [];
                               
                               // Mapping repairTracker data
                               const partReplacement = data?.femscheduledworkorderheaders[0]?.femscheduledwopartsreplacedetails.map((partDetails) => {
                                   return {
                                       itemPartCode: {
                                           id: partDetails?.itemcodeid || "",
                                           label: mapItemCode(partDetails?.itemcodeid) || "",
                                           unitCost:maptoUnitCost(partDetails?.itemcodeid) || "",
                                       },
                                       itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
                                       quantity: partDetails?.quantityused || "",
                                       partCost: parseFloat(partDetails?.partscost || 0)?.toFixed(2) || "",
                                       dummy_id: uuidv4() || "",
                                       timeStamp: partDetails?.timestamp || "",
                                       editmode: true
                                   };
                               }) || [];
       
                               const assetNo = {
                                   id: data?.assetId || "",
                                   label: data?.assetNo || "",
                                   workGroupId:data?.wgId || "",
                                   repairType:data?.femworespondtype || ""
                               };
       
                               const respondedBy = {
                                   id: data?.assessmentEmployeeId ? data?.assessmentEmployeeId : data?.scheduleEmployeeId || "",
                                   label:data?.assessmentEmployeename ? data?.assessmentEmployeename : data?.scheduleEmployeename || "",
                                   employeecode: mapEmployeeIdToCode(data?.assessmentEmployeeId || data?.scheduleEmployeeId) || "",
       
                               };
       
                               const taskcode = {
                                   id: data?.taskcodeId ? data?.taskcodeId : data?.scheduledTaskcodeId || "",
                                   label: data?.taskcode ? data?.taskcode : data?.scheduledTaskcode || ""
                               };
       
                               const partsRequired = {
                                   id: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                       ? 1
                                       : data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                           ? 2
                                           : "",
                                   label: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                       ? 'Yes'
                                       : data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                           ? 'No'
                                           : ""
                               };
       
                               const withPartsRequired = getStepper;
                               const withoutPartsRequired = getStepper?.filter((item) => item?.label !== 'Part Replacement');

                               if (partsRequired?.label === 'Yes' || partsRequired?.label === "") {
                                   dispatch(updateAssessmentsPartsInitialState("UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE", withPartsRequired));
                               } else {
                                   dispatch(updateAssessmentsPartsRequired("UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED", withoutPartsRequired));
                               };
       
       
                               const assetTakenLocation = {
                                   id: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                       ? 1
                                       : data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                           ? 2
                                           : "",
                                   label: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                       ? 'Yes'
                                       : data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                           ? 'No'
                                           : ""
                               };
       
       
                               const compRespondedBy = {
                                   id: data?.completionEmployeeId || "",
                                   label: data?.completionEmployeename || "",
                                   designation: mapEmployeeIdTodesignation(data?.completionEmployeeId) || ""
                               };
       
                               const vendor = {
                                   id: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid || data?.vendorId || "",
                                   label: maptoVendorDetails(data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid) || data?.vendorname || "",
                                   vendorcode: maptoVendorCode(data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid || data?.vendorId ) || ""
                               };
                               
                               const mappedData = {
                                workorderId: data?.workOrderId || "",
                                completionInfo: {
                                    respondedBy: compRespondedBy || '',
                                    designation: data?.completionDesignation || '',
                                    respondedDateandTime: data?.femscheduledworepairdetails?.[0]?.femscheduledwoassessmentheader?.[0]?.responsestartdate || "",
                                    duration: data?.duration || '',
                                    completionBy: {
                                        id: setvendorField ? vendor?.id : data?.completionByEmployeeId || "",
                                        label: setvendorField ? vendor?.label : data?.completionByEmployeename || "",
                                        value: setvendorField ? vendor?.label : data?.completionByEmployeename || ""
                                    },
                                    startDateandTime: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.startdate || '',
                                    endDateandTime: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.enddate || '',
                                    actionTaken: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.actiontaken || '',
                                    signatureFiles: [],
                                    timeStamp: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.timeStamp || "",
                                    costInfo: {
                                        editmode: true,
                                        breakDownCost: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : 0,
                                        poNumber: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || "",
                                        ppmCostByPurchaseOrder: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.ppmcost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : 0,
                                        poNumberByPurchaseOrder: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || "",
                                        ppmCostByContract: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : 0,
                                        contractReferenceNumber: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.contractrefno || "",
                                        totalSparePartCost: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.sparepartscost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.sparepartscost || 0)?.toFixed(2) : 0,
                                        totalWorkorderCost: data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.totalwocost ? parseFloat(data?.femscheduledworkorderheaders[0]?.femscheduledwocompletiondetails?.[0]?.totalwocost || 0)?.toFixed(2) : 0,
                                    }
                                },
                                assessments: {
                                    respondedBy: respondedBy || '',
                                    designation:data?.scheduleDesignation ? data?.scheduleDesignation : data?.assessmentDesignation || "",
                                    taskCode: taskcode || '',
                                    taskDescription:data?.taskdesc ? data?.taskdesc : data?.scheduledTaskdesc || '',
                                    repairType:data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype ? data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype : data?.femworespondtype || '',
                                    partsRequired: partsRequired || '',
                                    assetTakenLocation: assetTakenLocation || '',
                                    respondedFinding: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.respondfinding || '',
                                    repairTracker: repairTracker || [],
                                    vendor: vendor || '',
                                    outsourceRespondRemarks: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.respondremarks || "",
                                    timeStamp: data?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders?.[0]?.timestamp || "",
                                },
                                partReplacementRows: partReplacement || [],
                                vendorField: setvendorField,
                                
                            };
                               scheduledWorkorderDetails = mappedData || {};
                               setBasicDetailsData((prev)=>({
                                ...prev,
                                ...mappedData
                               }));
                               dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...mappedData }));

                               return mappedData;

       
                           } else {
                               const data = response?.[0];
                               const getRepairtype = data?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype ? data?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype : data?.bemworespondtype || ''
                               const setvendorField = getRepairtype === 'Outsource' ? true : false;
                               dispatch(updateOutsourceDetails("SET_VENDORFIELD", setvendorField));
                                      
                               const employeeResponse = await workOrderSummaryRepositry.fetchEmployeeDetails();
                               const lovOptionsResponse = await workOrderSummaryRepositry.lovOptions();
                               const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();
                               const itemCodeResponse = await workOrderSummaryRepositry.fetchItemCodeoptions(serviceType);
       
                               const mapEmployeeIdToName = (id) => {
                                   const employee = employeeResponse?.find(emp => emp?.id === id);
                                   return employee ? employee.employeename : '';
                               };
       
                               const mapEmployeeIdTodesignation = (id) => {
                                   const employee = employeeResponse?.find(emp => emp?.id === id);
                                   return employee ? employee?.designation : '';
                               };
       
                               const mapEmployeeIdToCode = (id) => {
                                   const employee = employeeResponse?.find(emp => emp?.id === id);
                                   return employee ? employee?.employeecode : '';
       
                               };
       
                               const mapFlagIdToLabel = (id) => {
                                   const flag = lovOptionsResponse?.femuschworepairflags?.find(f => f?.id === id);
                                   return flag ? flag?.repairflag : '';
                               };
       
                               const maptoVendorDetails = (id) => {
                                   const vendor = vendorDetails?.find(v => v?.id === id);
                                   return vendor ? vendor?.vendorname : '';
                               };
       
                               const maptoVendorCode = (id) => {
                                   const vendor = vendorDetails?.find(v => v?.id === id);
                                   return vendor ? vendor?.vendorcode : '';
                               };
       
                               const mapPicIdToLabel = (id) => {
                                   const pic = lovOptionsResponse?.femuschworepairpics?.find(p => p?.id === id);
                                   return pic ? pic?.repairpic : '';
                               };
       
                               const mapActivityIdToLabel = (id) => {
                                   const activity = lovOptionsResponse?.femuschworepairactivities?.find(a => a?.id === id);
                                   return activity ? activity?.repairactivity : '';
                               };
       
                               const mapItemCode = (id) => {
                                   const ic = itemCodeResponse?.find(ic => ic?.id === id);
                                   return ic ? ic.itemcode : '';
                               };
                               const mapItemDesc = (id) => {
                                   const ic = itemCodeResponse?.find(ic => ic?.id === id);
                                   return ic ? ic?.descriptionname : '';
                               };
       
                               const maptoUnitCost = (id) => {
                                   const ic = itemCodeResponse?.find(ic => ic?.id === id);
                                   return ic ? ic?.unitcost : '';
                               };
       
                               // Mapping repairTracker data
                               const repairTracker = data?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders?.[0]?.bemscheduledworepairdetails?.map((repairDetail) => {
                                   return {
                                       employeename: {
                                           id: repairDetail?.employeeid || "",
                                           employeename: mapEmployeeIdToName(repairDetail?.employeeid) || "",
                                           employeecode: mapEmployeeIdToCode(repairDetail?.employeeid) || ""
                                       },
                                       flag: {
                                           id: repairDetail?.bemschworepairflagId || '',
                                           label: mapFlagIdToLabel(repairDetail?.bemschworepairflagId) || ''
                                       },
                                       pic: {
                                           id: repairDetail?.bemschworepairpicId || '',
                                           label: mapPicIdToLabel(repairDetail?.bemschworepairpicId) || ''
                                       },
                                       activity: {
                                           id: repairDetail.bemschworepairactivityId || '',
                                           label: mapActivityIdToLabel(repairDetail?.bemschworepairactivityId) || ''
                                       },
                                       technician: repairDetail?.vendortechnician || "",
                                       startDateandTime: repairDetail?.repairstartdate || "",
                                       endDateandTime: repairDetail?.repairenddate || "",
                                       repairDuration: repairDetail?.repairduration || "",
                                       remarks: repairDetail?.remarks || '',
                                       preparationHours: repairDetail?.preparationhours || '',
                                       verificationHours: repairDetail?.verificationhours || '',
                                       dummy_id: uuidv4() || "",
                                       timeStamp: repairDetail?.timestamp || ""
                                   };
                               }) || [];
       
                               const partReplacement = data?.bemscheduledworkorderheaders[0]?.bemscheduledwopartsreplacedetails?.map((partDetails) => {
                                   return {
                                       itemPartCode: {
                                           id: partDetails?.itemcodeid || "",
                                           label: mapItemCode(partDetails?.itemcodeid) || "",
                                           unitCost: maptoUnitCost(partDetails?.itemcodeid) || ""
                                       },
                                       itemDescription: mapItemDesc(partDetails?.itemcodeid) || "",
                                       quantity: partDetails?.quantityused || "",
                                       partCost: parseFloat(partDetails?.partscost || 0).toFixed(2) || "",
                                       dummy_id: uuidv4() || "",
                                       editmode: true,
                                       timeStamp: partDetails?.timestamp || "",
                                   };
                               }) || [];
    
       
                               const respondedBy = {
                                   id: data?.assessmentEmployeeId ? data?.assessmentEmployeeId : data?.scheduleEmployeeId || "",
                                   label:data?.assessmentEmployeename ? data?.assessmentEmployeename : data?.scheduleEmployeename || "",
                                   employeecode: mapEmployeeIdToCode(data?.assessmentEmployeeId || data?.scheduleEmployeeId) || "",
                               };
       
                               const taskcode = {
                                   id: data?.taskcodeId ? data?.taskcodeId : data?.scheduledTaskcodeId || "",
                                   label: data?.taskcode ? data?.taskcode : data?.scheduledTaskcode || ""
                               };
       
                               const partsRequired = {
                                   id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                       ? 1
                                       : data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                           ? 2
                                           : "",
                                   label: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.ispartsrequired === true
                                       ? 'Yes'
                                       : data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.ispartsrequired === false
                                           ? 'No'
                                           : ""
                               };
                               const withPartsRequired = getStepper;
                               const withoutPartsRequired = getStepper?.filter((item) => item?.label !== 'Part Replacement');
           
                               if (partsRequired?.label === 'Yes' || partsRequired?.label === "") {
                                   dispatch(updateAssessmentsPartsInitialState("UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE", withPartsRequired));
                               } else {
                                   dispatch(updateAssessmentsPartsRequired("UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED", withoutPartsRequired));
                               };

       
                               const assetTakenLocation = {
                                   id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                       ? 1
                                       : data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                           ? 2
                                           : "",
                                   label: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === true
                                       ? 'Yes'
                                       : data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.isassettakenoutlocation === false
                                           ? 'No'
                                           : ""
                               };
       
                               const compRespondedBy = {
                                   id: data?.completionEmployeeId || "",
                                   label: data?.completionEmployeename || "",
                                   designation: mapEmployeeIdTodesignation(data?.completionEmployeeId) || ""
                               };
       
                               const vendor = {
                                   id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid || data?.vendorId || "",
                                   label: maptoVendorDetails(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid) || data?.vendorname || "",
                                   vendorcode: maptoVendorCode(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid || data?.vendorId ) || ""
                               };
                                      
                               const mappedData = {
                                workorderId: data?.workOrderId || "",
                                completionInfo: {
                                    id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.id || '',
                                    respondedBy: compRespondedBy || '',
                                    designation: data?.completionDesignation || '',
                                    respondedDateandTime: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheader?.[0]?.responsestartdate || "",
                                    duration: data?.duration || '',
                                    completionBy: {
                                        id: setvendorField ? vendor?.id : data?.completionByEmployeeId || "",
                                        label: setvendorField ? vendor?.label : data?.completionByEmployeename || "",
                                        value: setvendorField ? vendor?.label : data?.completionByEmployeename || ""
                                    },
                                    startDateandTime: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.startdate || '',
                                    endDateandTime: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.enddate || '',
                                    actionTaken: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.actiontaken || '',
                                    signatureFiles: [],
                                    timeStamp: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.timestamp || '',
                                    costInfo: {
                                        editmode: true,
                                        breakDownCost: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.breakdowncost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.breakdowncost || 0)?.toFixed(2) : 0,
                                        poNumber: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || '',
                                        ppmCostByPurchaseOrder: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcost || 0)?.toFixed(2) : 0,
                                        poNumberByPurchaseOrder: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || '',
                                        ppmCostByContract: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.contractppmcost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.contractppmcost || 0)?.toFixed(2) : 0,
                                        contractReferenceNumber: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.contractrefno || '',
                                        totalSparePartCost: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.sparepartscost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.sparepartscost || 0)?.toFixed(2) : 0,
                                        totalWorkorderCost: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.totalwocost ? parseFloat(data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.totalwocost || 0)?.toFixed(2) : 0
                                    }
                                },
                                assessments: {
                                    id: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders[0]?.id || '',
                                    respondedBy: respondedBy || '',
                                    designation: data?.scheduleDesignation ? data?.scheduleDesignation : data?.assessmentDesignation || "",
                                    taskCode: taskcode || '',
                                    taskDescription: data?.taskdesc ? data?.taskdesc : data?.scheduledTaskdesc || '',
                                    repairType:data?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype ? data?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype : data?.bemworespondtype || '',
                                    partsRequired: partsRequired || '',
                                    assetTakenLocation: assetTakenLocation || '',
                                    respondedFinding: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.respondfinding || '',
                                    repairTracker: repairTracker || [],
                                    timeStamp: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.timestamp || "",
                                    vendor: vendor || "",
                                    outsourceRespondRemarks: data?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.respondremarks || "",
                                },
                                partReplacementRows: partReplacement,
                                vendorField: setvendorField,
                            };
                               scheduledWorkorderDetails = mappedData || {};
                               setBasicDetailsData((prev)=>({
                                ...prev,
                                ...mappedData
                               }));
                               dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...mappedData }));
                               return mappedData;
                           };
                           
   };

   

    useEffect(() => {
        setLoading(true);
        
        Promise.all([
            workOrderNoOptions(),
            referenceTypeOptions()
        ])
            .then(() => {
                fetchData();
                if (basicDetails?.id) {
                    setBasicDetailsData(basicDetails);
                } else {
                    setBasicDetailsData((prev) => ({
                        ...prev,
                        workorderDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                        recivedDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                    }));
                }

            })
            // .finally(() => {
            //     setLoading(false);  // Set loading to false after everything is done
            // });
    }, []);


    const handleSubmit = async (e) => {
        setLoading(true)
        e.preventDefault();
        const isValid = handleValidationForRequiredFields();

        if (isValid) {
            if (basicDetails?.id) {

                const updatePayload = {
                    [`${serviceType}scheduledworkorderheaderId`]: basicDetailsdata?.referenceWorkOrderNo.id || "",
                    schcorrectiveno: basicDetails?.schcorrectiveno || "",
                    workorderdate: basicDetailsdata?.workorderDateandTime || "",
                    targetdate: basicDetailsdata?.issueDateandTimeBasicDetails || "",
                    requestdetails: basicDetailsdata?.requestDetails || "",
                    receivedbyid: basicDetailsdata?.receivedbyid || "",
                    cancelledby: basicDetailsdata?.cancelledBy || "",
                    receiveddate: basicDetailsdata?.recivedDateandTime || "",
                    cancellationreason: basicDetailsdata?.reasonforCancellation || "",
                    isppmused: basicDetailsdata?.isppmused || false,
                    [`${serviceType}assetregisterId`]: basicDetailsdata?.assetId || "",
                    [`${serviceType}workorderstatusId`]: mappedStatus || "",
                    completeddate: basicDetailsdata?.completeddate || "",
                    Processingpercentage: processingPercentage || "",
                    [`${serviceType}scmreferencetypeId`]: basicDetailsdata?.referenceType?.id || "",
                    id: basicDetails?.id || ""
                };
                const updateWorkOrder = await ScmRepositry.updateBasicDetails(serviceType, updatePayload);
                if(updateWorkOrder?.id){
                    dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...basicDetailsdata, id: updateWorkOrder?.id, workOrderNo: updateWorkOrder?.workorderno }));
                    setPage("Assessments");
                    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                } else if (updateWorkOrder?.response?.data?.status >= 405){
                    setErrorDialog(true);
                    setErrorDialogMssg("An unexpected error occurred while processing your request.")
                }
            }
            else {
                const workOrderPayload = {
                    [`${serviceType}scheduledworkorderheaderId`]: basicDetailsdata?.referenceWorkOrderNo.id || "",
                    workorderdate: basicDetailsdata?.workorderDateandTime || "",
                    targetdate: basicDetailsdata?.issueDateandTimeBasicDetails || "",
                    requestdetails: basicDetailsdata?.requestDetails || "",
                    receivedbyid: basicDetailsdata?.receivedbyid || "",
                    cancelledby: basicDetailsdata?.cancelledBy || "",
                    receiveddate: basicDetailsdata?.recivedDateandTime || "",
                    cancellationreason: basicDetailsdata?.reasonforCancellation || "",
                    isppmused: basicDetailsdata?.isppmused || false,
                    [`${serviceType}assetregisterId`]: basicDetailsdata?.assetId || "",
                    [`${serviceType}workorderstatusId`]: statusList?.open?.id, //Open Status ID for initial create workorder
                    completeddate: basicDetailsdata?.completeddate || "",
                    Processingpercentage: processingPercentageValue?.basicDetails,
                    facilityid: facilityId || "",
                    token: token || "",
                    [`${serviceType}scmreferencetypeId`]: basicDetailsdata?.referenceType?.id || "",
                };
                const createWorkOrder = await ScmRepositry.createBasicDetails(serviceType, workOrderPayload);
                if(createWorkOrder?.id){
                    dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...basicDetailsdata, id: createWorkOrder?.id, schcorrectiveno: createWorkOrder?.schcorrectiveno }));
                    dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: statusList?.open?.label, percentage: processingPercentageValue?.basicDetails }));
                    setPage("Assessments");
                    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                } else if (createWorkOrder?.response?.data?.status >= 405){
                    setErrorDialog(true);
                    setErrorDialogMssg("An unexpected error occurred while processing your request.")
                }
            };
            
        };
        setLoading(false);
    };

    const onEnabledChange = (name) => {
        if (name === "yes") {
            setEnable(true)
        }
        else if (name === "no") {
            setEnable(false)
        }
    };

    const handleConfirm = async (updatedValues) => {
        setLoading(true);
        const isValid = handleValidationForRequiredFields();
        isValid ? (() => {
            onEnabledChange("yes");
            setBasicDetailsData((prev) => ({
                ...prev,
                cancelledBy: updatedValues.cancelledBy,
                reasonforCancellation: updatedValues.reasonforCancellation,
            }));
        })()
            : onEnabledChange("no");

        const updatePayload = {
            schcorrectiveno: basicDetails?.schcorrectiveno || "",
            workorderdate: basicDetailsdata?.workorderDateandTime || "",
            targetdate: basicDetailsdata?.issueDateandTimeBasicDetails || "",
            requestdetails: basicDetailsdata?.requestDetails || "",
            receivedbyid: basicDetailsdata?.receivedbyid || "",
            cancelledby: basicDetailsdata?.cancelledBy || "",
            receiveddate: basicDetailsdata?.recivedDateandTime || "",
            cancellationreason: basicDetailsdata?.reasonforCancellation || "",
            isppmused: basicDetailsdata?.isppmused || false,
            [`${serviceType}assetregisterId`]: basicDetailsdata?.assetId || "",
            [`${serviceType}workorderstatusId`]: statusList?.cancelled?.id, //Cancel status for workorder
            [`${serviceType}scheduledworkorderheaderId`]: basicDetailsdata?.referenceWorkOrderNo.id || "",
            completeddate: basicDetailsdata?.completeddate || "",
            Processingpercentage: processingPercentage || "",
            facilityid: facilityId || "",
            token: token,
            [`${serviceType}scmreferencetypeId`]: basicDetailsdata?.referenceType?.id || "",
            id: basicDetails?.id || ""
        };

        if (isValid) {
            const cancelWorkOrder = await ScmRepositry.updateBasicDetails(serviceType, updatePayload);
            dispatch(updateBasicDetailsWorkOrder("UPDATE_BASIC_DETAILS_WORK_ORDER_SUMMARY", { ...basicDetailsdata, id: cancelWorkOrder?.id }));
            dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: statusList?.cancelled?.label, percentage: processingPercentage }))
        };
        setLoading(false);
    };

    const handleCloseErrRequestDialog = () => {
		setErrorDialog(false);
		setErrorDialogMssg("");
	};
	
	const handleConfirmErrRequestDialog = (e) => {
		e.preventDefault();
		setErrorDialog(false);
		setErrorDialogMssg("")
	};

    return (

        <>
            <PageLoader open={loading} />
            <ComponentHeader
                mainHeader={findHeaderContent?.mainHeader}
                subHeader={findHeaderContent?.subHeader}
                secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
                requiredButton={viewmode ? false : findHeaderContent?.requiredButton}
            />
            <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                <form style={{ position: "relative" }} onSubmit={(e) => handleSubmit(e)} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="SCM Corrective No(Auto)"
                                id="schcorrectiveno"
                                name="schCorrectiveNo"
                                value={basicDetailsdata?.schcorrectiveno || ""}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomSelectInput
                                label={"Reference Type"}
                                id="referenceType"
                                name="referenceType"
                                options={basicDetailsOptions?.referenceType || []}
                                value={basicDetailsdata?.referenceType || []}
                                onChange={handleOnchange}
                                placeholder={"Select Reference"}
                                disabled={editmode || viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}

                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextFieldWithSearch
                                // label="Reference PPM/RI Work Order No"
                                label="Reference PPM Work Order No"
                                id="referenceNo"
                                name="referenceWorkOrderNo"
                                value={basicDetailsdata?.referenceWorkOrderNo || ""}
                                onChange={handleOnchange}
                                options={basicDetailsOptions?.workOrderNo || []}
                                disabled={editmode || viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || basicDetails?.id}
                                autoFocus
                                error={error?.referenceWorkOrderNo}
                                isMandatoryField={true}
                                helperText={errorMessage?.referenceWorkOrderNo}
                            />
                        </Grid>
                        <Grid item xs={6} md={4} sm={6}>
                            <CustomDateTimePicker
                                label="Work Order Date and Time"
                                value={basicDetailsdata?.workorderDateandTime || ""}
                                onDateChange={(e) => handleOnchange(e, "workorderDateandTime")}
                                helperText={errorMessage?.workorderDateandTime}
                                error={error?.workorderDateandTime}
                                isMandatoryField={true}
                                disableFutureDate={false}
                                disabled={true}
                                displayDefaultValue={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Asset No."
                                id="assetno"
                                name="assetNo"
                                value={basicDetailsdata?.assetNo || ""}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Old Asset No."
                                id="oldAssetNo"
                                name="oldAssetNo"
                                value={basicDetailsdata?.oldAssetNo || ""}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Description"
                                id="description"
                                name="description"
                                value={basicDetailsdata?.description || ""}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Under Warranty"
                                id="underwarrenty"
                                name="underwarrenty"
                                value={basicDetailsdata?.underwarrenty || ""}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Location"
                                id="location"
                                name="location"
                                value={basicDetailsdata?.location || ""}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sm={6}>
                            <CustomTextField
                                label="Work Group & Description"
                                id="workgroupDescription"
                                name="workgroupDescription"
                                value={basicDetailsdata?.workgroupDescription || ""}
                                disabled
                            />
                        </Grid>
                    </Grid>
                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                        <Typography variant='title2' > Request details </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8} sm={8}>
                                <CustomTextArea
                                    label="Request Details"
                                    id="requestDetails"
                                    value={basicDetailsdata?.requestDetails || ""}
                                    onChange={(e) => handleOnchange(e, "requestDetails","Request Details")}
                                    error={error?.requestDetails}
                                    isMandatoryField={true}
                                    helperText={errorMessage?.requestDetails}
                                    disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}
                                    maxLength={255}
                                />
                            </Grid>
                        </Grid>
                    </Box>


                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                        <Typography variant='title2' >Work Order Receipt and Classification</Typography>
                        <Grid container spacing={2}>

                            <Grid item xs={12} md={4} sm={6}>
                                <CustomDateTimePicker
                                    label="Received Date and Time"
                                    value={basicDetailsdata?.recivedDateandTime || null}
                                    onDateChange={(e) => handleOnchange(e, "recivedDateandTime")}
                                    isMandatoryField={true}
                                    error={error?.recivedDateandTime}
                                    helperText={errorMessage?.recivedDateandTime}
                                    disableFutureDate={false}
                                    displayDefaultValue={false}
                                   // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6}
                                   disabled={true}
                                />
                            </Grid>

                            {checkcancelWOStatus && (
                                <>
                                    <Grid item xs={12} md={4} sm={6}>
                                        <CustomTextField
                                            label="Cancelled By"
                                            id="cancelledBy"
                                            name="cancelledBy"
                                            value={basicDetailsdata?.cancelledBy || ""}
                                            onChange={handleOnchange}
                                            disabled={true}
                                        />
                                    </Grid>
                                </>
                            )}
                        </Grid>

                    </Box>

                    {checkcancelWOStatus && (
                        <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4} sm={4}>
                                    <CustomTextArea
                                        label="Reason for Cancellation"
                                        id="reasonforCancellation"
                                        value={basicDetailsdata?.reasonforCancellation || ""}
                                        onChange={(e) => handleOnchange(e, "reasonforCancellation")}
                                        disabled={true}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    )}


                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: { xs: "center", md: "flex-end" },
                            mt: 3,
                        }}
                    >
                        <ScmBottomButtonsforWorkOrder page={page} buttonAttributes={buttonAttributes} cancelWo={viewmode ? false : checkcancelWOStatus} onEnableChange={onEnabledChange} enabel={enable} enableAuthorizeButton={enable} onConfirm={handleConfirm} />
                    </Box>
                </form>
            </Box>

            <CustomAlert
                open={errorDialog}
                onClose={handleCloseErrRequestDialog}
                onConfirm={handleConfirmErrRequestDialog}
                content={errorDialogMssg}
                confirmBtn='OK'
            />
        </>


    );
};

export default ScmBasicDetails;
